import { PackageSettingsFormWebComponent } from './component/PackageSettingsFormWebComponent';
import { WEB_COMPONENT_PACKAGE_SETTINGS_FORM } from '../../../webcomponents.constants';

export { PackageSettingsFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_SETTINGS_FORM, PackageSettingsFormWebComponent);
